import { Fragment } from 'react';
import {
  Grid,
  Box,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  RadioGroup,
  Radio,
  useTheme,
} from '@mui/material';
import SectionTitle from '../../components/SectionTitle';
import { IFormValues, IFormWatch } from 'routes/Main/type';
import useTableForm from '../../hooks/useTableForm';
import MuiRadioGroupSub from './MuiRadioGroupSub';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
}

const BDIContents = (props: Props) => {
  const { palette } = useTheme();

  const { radioGroup, sumValues } = useTableForm(props);
  const { disabled, watch, setValue, getValues } = props;

  const titles = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
  ];

  const answers = [
    [
      'Tôi không cảm thấy buồn.',
      'Nhiều lúc tôi cảm thấy buồn.',
      'Lúc nào cũng buồn và tôi không thể thoát ra được.',
      'Tôi buồn và không vui đến nỗi không chịu nổi.',
    ],
    [
      'Tôi không nản lòng về tương lai.',
      'Tôi cảm thấy nản lòng về tương lai hơn trước.',
      'Tôi cảm thấy chẳng có gì để mong đợi ở tương lai cả.',
      'Tôi cảm thấy tương lai là vô vọng và mọi thứ không thể cải thiện được.',
    ],
    [
      'Tôi không cảm thấy mình là kẻ thất bại.',
      'Tôi cảm thấy mình đã thất bại nhiều hơn những người khác.',
      'Nhìn lại cuộc sống của mình, tôi thấy mình đã có quá nhiều thất bại.',
      'Tôi cảm thấy mình là một người hoàn toàn thất bại.',
    ],
    [
      'Tôi còn thích thú với những điều mà trước đây tôi vẫn thường thích.',
      'Tôi ít thấy thích thú với những điều mà trước đây tôi vẫn thường thích.',
      'Tôi còn rất ít thích thú với những điều mà trước đây tôi vẫn thường thích.',
      'Tôi không còn chút thích thú nào nữa.',
    ],
    [
      'Tôi không cảm thấy tội lỗi gì ghê gớm cả.',
      'Tôi cảm thấy tội lỗi phần lớn thời gian.',
      'Hầu như lúc nào tôi cũng cảm thấy tội lỗi.',
      'Lúc nào tôi cũng cảm thấy tội lỗi.',
    ],
    [
      'Tôi không cảm thấy mình đang bị trừng phạt.',
      'Tôi cảm thấy có lẽ mình đang bị trừng phạt.',
      'Tôi mong chờ bị trừng phạt.',
      'Tôi cảm thấy mình đang bị trừng phạt.',
    ],
    [
      'Tôi không cảm thấy thất vọng về bản thân mình.',
      'Tôi không còn tin tưởng vào bản thân.',
      'Tôi thất vọng với bản thân mình.',
      'Tôi ghét bản thân mình.',
    ],
    [
      'Tôi không cảm thấy mình tệ hơn bất cứ ai khác.',
      'Tôi nghiêm khắc với bản thân vì những yếu điểm hoặc sai lầm của mình.',
      'Tôi phê phán bản thân vì lỗi lầm của mình.',
      'Tôi tự trách mình vì mọi chuyện tồi tệ xảy ra.',
    ],
    [
      'Tôi không có ý định tự tử.',
      'Tôi có ý định tự tử, nhưng tôi không thực hiện chúng.',
      'Tôi muốn tự tử.',
      'Tôi sẽ tự tử nếu có cơ hội.',
    ],
    [
      'Tôi không khóc nhiều hơn bình thường.',
      'Hiện tại tôi khóc nhiều hơn trước đây.',
      'Hiện tại tôi thường xuyên khóc.',
      'Vốn dĩ tôi đã có thể khóc, nhưng bây giờ tôi không thể khóc dù mình muốn khóc.',
    ],
    [
      'Tôi không còn bị kích dộng bởi những thứ trước đây nữa.',
      'Bây giờ tôi thấy dễ kích động hơn bình thường một chút.',
      'Tôi khá khó chịu hoặc bực bội trong phần lớn thời gian.',
      'Tôi luôn cảm thấy bực bội.',
    ],
    [
      'Tôi không mất hứng thú với người khác.',
      'Tôi ít quan tâm đến mọi người hơn so với trước đây.',
      'Tôi đã đánh mất phần lớn sự quan tâm đến mọi người.',
      'Tôi đã không còn quan tâm đến bất kì điều gì nữa.',
    ],
    [
      'Tôi đưa ra quyết định tốt nhất có thể.',
      'Tôi trì hoãn việc đưa ra quyết định nhiều hơn trước đây.',
      'Tôi gặp nhiều khó khăn hơn trong việc ra quyết định nhiều hơn trước đây.',
      'Tôi không thể đưa ra quyết định nữa.',
    ],
    [
      'Tôi không cảm thấy mình trông tệ hơn trước nữa.',
      'Tôi lo lắng rằng tôi trông già đi hoặc không hấp dẫn.',
      'Tôi cảm thấy có những thay đổi vĩnh viễn về ngoại hình của mình khiến tôi trông không hấp dẫn.',
      'Mình tin là mình trông xấu xí.',
    ],
    [
      'Tôi có thể làm việc tốt như trước đây.',
      'Cần phải nỗ lực hơn nữa để bắt đầu làm điều gì đó.',
      'Tôi phải cố gắng hết sức để làm bất cứ điều gì.',
      'Tôi không thể làm bất cứ việc gì.',
    ],
    [
      'Tôi không thấy có chút thay đổi gì trong giấc ngủ của tôi.',
      'Tôi không còn ngủ ngon như trước nữa.',
      'Tôi thức dậy sớm hơn bình thường 1-2 tiếng và thấy khó ngủ lại.',
      'Tôi thức dậy sớm hơn vài giờ so với trước đây và không thể ngủ lại được.',
    ],
    [
      'Tôi không dễ mệt mỏi hơn bình thường.',
      'Tôi dễ mệt mỏi hơn trước đây.',
      'Tôi mệt mỏi khi làm hầu hết mọi việc.',
      'Tôi quá mệt để làm bất cứ điều gì.',
    ],
    [
      'Sự thèm ăn của tôi không tệ hơn bình thường.',
      'Sự thèm ăn của tôi không còn như trước nữa.',
      'Bây giờ tôi thấy chán ăn hơn nhiều rồi.',
      'Tôi không còn thèm ăn nữa.',
    ],
    [
      'Gần đây tôi không giảm cân nhiều, nếu có.',
      'Tôi đã giảm hơn năm pound.',
      'Tôi đã giảm hơn mười pound.',
      'Tôi đã giảm hơn mười lăm pound.',
    ],
    [
      'Tôi không lo lắng về sức khỏe của mình hơn bình thường.',
      'Tôi lo lắng về các vấn đề thể chất của mình như đau nhức, đau nhức, đau bụng, hoặc táo bón.',
      'Tôi rất lo lắng về các vấn đề thể chất và khó có thể nghĩ đến nhiều thứ khác.',
      'Tôi quá lo lắng về các vấn đề thể chất của mình đến nỗi tôi không thể nghĩ ra bất cứ điều gì khác.',
    ],
    [
      'Gần đây tôi không nhận thấy có sự thay đổi nào trong sở thích tình dục của mình.',
      'Tôi ít quan tâm đến tình dục hơn trước đây.',
      'Tôi hầu như không có hứng thú với tình dục.',
      'Tôi hoàn toàn mất hứng thú với tình dục.',
    ],
  ];

  const watchSumValues = () => {
    const values = titles.map((_, i) =>
      watch(`content[${i}]`) ? Number(watch(`content[${i}]`)) : 0
    );
    let sum = sumValues(values);
    if (watch('content[19]') && watch('content[19]') == 1) sum--;
    setValue('sum', sum);
    return sum;
  };

  return (
    <Fragment>
      {titles.map((title, idx) => (
        <>
          <SectionTitle title={title} />
          <Grid item xs={12}>
            <RadioGroup
              name={title}
              defaultValue={Number(getValues(`content[${idx}]`))}
            >
              <Table aria-label="simple table">
                <TableBody>
                  {answers[idx].map((answer, i) => {
                    if (idx === 19) {
                      return (
                        <TableRow key={answer}>
                          <TableCell sx={{ width: '80%' }}>{answer}</TableCell>
                          <TableCell>
                            <MuiRadioGroupSub
                              i18nKey="YESORNO"
                              values={[1, 2]}
                              name={title}
                              disabled={disabled}
                              defaultValue={Number(getValues('content[19]'))}
                              onChange={i => setValue(`content[19]`, i)}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    }

                    return (
                      <TableRow key={answer}>
                        <TableCell sx={{ width: '80%' }}>{answer}</TableCell>
                        <TableCell sx={{ width: '10%' }}>{`${i}`}</TableCell>
                        <TableCell>
                          <Radio
                            disabled={disabled}
                            name={title}
                            value={i}
                            onChange={() => setValue(`content[${idx}]`, i)}
                            sx={{
                              '&.Mui-checked': {
                                color: '#2D73DC',
                              },
                              height: '44px',
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </RadioGroup>
          </Grid>
        </>
      ))}

      <Grid item xs={12}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
          <Typography
            gutterBottom
            minWidth={115}
            fontWeight={700}
            variant="subtitle1"
          >
            Tổng : {watchSumValues()}
          </Typography>
          <Typography
            minWidth={115}
            variant="caption"
            sx={{ color: `${palette.primary.dark}` }}
          >
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                0-10
              </Box>
              : Những thăng trầm này được coi là bình thường
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                11-16
              </Box>
              : Xáo trộn cảm xúc nhẹ
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                17-20
              </Box>
              : Trầm cảm lâm sàng
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                21-30
              </Box>
              : Trầm cảm nhẹ
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                31-40
              </Box>
              : Trầm cảm nặng
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                over 40
              </Box>
              : Trầm cảm nghiêm trọng
            </Typography>
          </Typography>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default BDIContents;
